import combineStyles from 'components/Templates/general/combineStyles';

import {
  wrapperStyles,
  centerAlignStyles,
  galleryImagesStyles
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  sectionWrapperStyles,
  wrapperWithMarginStyles,
  wrapperWithMarginTabletStyles,
  typoParagraph,
  horizontalWrapperStyles
} from 'components/Templates/styles/Red/commonObjectsStyles';

import buttonStyles from 'components/Templates/styles/Red/buttonStyles';
import heroInset from 'components/Templates/styles/Red/assets/JPG/backgrounds/Hero_inset.jpg';

import defaultLogo from 'assets/sample_logo_white.png';

/* eslint-disable */
const thisStyle = {
  wrapper: {
    '0': {
      ...sectionWrapperStyles,
      ...wrapperStyles,
      'display': 'flex',
      'justify-content': 'center',
      'align-items': 'center',
      'background-color': '{invertedBackgroundColor}',
      'padding-top' : '10rem',
      'padding-bottom' : '20rem',
      'display': 'flex'
    },
    '76_8' : {
      'padding-left' : '6%',
      'padding-right' : '6%'
    },
    '37_5' : {
      'padding-top' : '3rem',
      'padding-bottom' : '4.5rem'
    }
  },
  horizontalWrapper: {
    '0': {
      ...horizontalWrapperStyles,
      ...wrapperWithMarginStyles
    },
    '76_8' : {
      ...wrapperWithMarginTabletStyles,
      'width': '100%'
    },
    '37_5' : {
      'flex-direction': 'column'
    }
  },
  heroImageWrapper: {
    '0': {
      ...galleryImagesStyles,
      'flex': 1,
      'width': '45rem',
      'padding-right': '10%'
    },
    '76_8': {
      'width': '35rem',
      'height': 'auto',
      'padding-right': '2rem'
    },
    '37_5' : {
      'width': '15rem',
      'height': '20rem',
      'padding-right': 0
    }

  },
  heroImage: {
    '0': {
      'background-image': 'url('+heroInset+')',
      'background-size': 'cover',
      'background-position': 'center',
      'width': '100%',
      'height': '100%',
    },
    '76_8' : {
      'margin-right': '1rem',
    },
  },
  eventVenueWrapper: {
    '0': {
      'position': 'relative',
      'display': 'block',
      'z-index': '2',
      'float': 'right',
      'top': '5rem',
      'z-index': '2'
    },
    '76_8' : {
      'top': '0',
      'float': 'none'
    },
  },
  eventDate: {
    '0': {
      'color': '{lightSecondaryTextColor}',
      'text-align': 'left',
      'font-size': '1.8rem',
      'font-family': '{mainFont}',
      'font-weight': '700',
      'margin-bottom': '1rem'
    }
  },
  eventVenueTitle: {
    '0': {
      'color': '{lightSecondaryTextColor}',
      'text-align': 'left',
      'font-size': '1.8rem',
      'font-family': '{mainFont}',
      'font-weight': '700',
      'margin-bottom': '0.5rem'
    }
  },
  eventVenueAddress: {
    '0': {
      'color': '{lightSecondaryTextColor}',
      'text-align': 'left',
      'font-size': '1.8rem',
      'font-family': '{mainFont}'
    }
  },
  eventVenueCity: {
    '0': {
      'color': '{lightSecondaryTextColor}',
      'text-align': 'left',
      'font-size': '1.8rem',
      'font-family': '{mainFont}'
    }
  },
  eventCity: {
    '0': {
      'color': '{lightSecondaryTextColor}',
      'text-align': 'left',
      'font-size': '1.8rem',
      'font-family': '{mainFont}'
    }
  },
  eventDetails: {
    '0': {
      'color': '{lightSecondaryTextColor}',
      'text-align': 'left',
      'font-size': '1.8rem',
      'font-family': '{mainFont}'
    },
    '76_8': {
      'margin-bottom': '1rem',
    },
  },

  heroCenterWrapper: {
    '0': {
      ...centerAlignStyles,
      'flex': 1,
    },
    '76_8': {
      'flex': 1,
    },
    '37_5': {
      'padding-top': '3rem',
      'margin-left': '0'
    }
  },
  title: {
    '0': {
      'margin-top' : '3rem',
      'margin-bottom' : '3.5rem',
      'color': '{lightTextColor}',
      'text-align': 'left',
      'font-size': '9rem',
      'font-weight': '400',
      'font-family': '{mainFont}',
    },
    '76_8' : {
      'font-size': '7rem',
      'margin-top' : '4rem',
      'margin-bottom' : '1rem',
    },
    '37_5' : {
      'font-size': '4.5rem',
      'margin-top' : '1.5rem',
      'margin-bottom' : '1.5rem',
    }
  },
  paragraph: {
    '0': {
      ...typoParagraph,
      'margin-bottom': '5rem',
      'font-size': '1.8rem',
      'text-align': 'left',
      'width': '85%',
      'color': '{lightTextColor}',
    },
    '37_5' : {
      'margin-bottom' : '3rem',
      'width': '100%',
    }
  },
  headlineSponsorTitle: {
    '0': {
      ...typoParagraph,
      'font-size': '1.8rem',
      'text-align': 'left',
      'width': '90%',
      'color': '{lightTextColor}',
      'display': 'none',
      'margin-bottom': '2.5rem',
    },
    '37_5' : {
      'margin-bottom' : '3rem',
      'width': '100%',
    }
  },
  headlineSponsorLogo: {
    '0': {
      'height': '5rem',
      'width': '5rem',
      'background-size': 'contain',
      'background-position': 'center',
      'background-repeat': 'no-repeat',
      'display': 'none',
      'margin-bottom': '5rem',
      'background-image': `url(${defaultLogo})`
    },
    '37_5' : {
      'margin-bottom' : '3rem',
      'width': '100%',
    }
  },
  buttonsCenterWrapper: {
    '0': {
      'display': 'flex',
      'flex-wrap': 'wrap'
    },
    '37_5' : {
      'flex-direction' : 'column',
      'align-items' : 'center'
    }
  },
  faviconImage: {
    '0': {
      'height': '6rem',
      'background-size': 'contain',
      'background-repeat': 'no-repeat',
      'top': '2.5rem'
    },
    '76_8' : {
      'height': '4rem',
    },
    '37_5' : {
      'top': '1rem',
      'height': '3.5rem',
    }
  },
};

export default combineStyles(thisStyle, buttonStyles);
